import React, {useState} from 'react';
import './style.scss';

const PrivacyPolicy = ({showDocuments = true}) => {
  const [delAccInstru, setDelAccInstru] = useState(false)

  const delAccFunc = () => {
    return (
      <div style={{ padding: "10px", overflowY: "scroll", pointerEvents: "auto", height: "100%", display: "block" }}>
        <h3>Hướng dẫn xóa dữ liệu đăng nhập bằng tài khoản Google, Facebook, Apple ID</h3>
        <div>
          Quý khách thực hiện các thao tác sau để xóa dữ liệu đăng nhập bằng tài khoản Google, Facebook, Apple ID:<br />
          <ul>
            <li>1. Truy cập ứng dụng My VNPT, chọn Danh mục khác, sau đó chọn Cài đặt</li>
            <li>2. Chọn chức năng Xóa tài khoản</li>
            <li>3. Đọc điều khoản dịch vụ, chọn đồng ý để tiếp tục</li>
            <li>4. Bấm xác nhận Xóa tài khoản</li>
          </ul>
          Trường hợp đã thực hiện liên kết tài khoản với số điện thoại di động, Quý khách chỉ cần thực hiện xóa liên kết đó để xóa dữ liệu đăng nhập bằng tài khoản Google, Facebook, Apple ID. Các bước thực hiện như sau:<br />
          <ul>
            <li>1. Truy cập ứng dụng My VNPT, chọn Danh mục khác, sau đó chọn Cài đặt</li>
            <li>2. Chọn chức năng Xóa liên kết tài khoản Google/Facebook/Apple ID</li>
            <li>3. Đọc điều khoản dịch vụ, chọn đồng ý để tiếp tục</li>
            <li>4. Nhập mã OTP gửi về số điện thoại liên kết và bấm Tiếp tục để xóa liên kết</li>
          </ul>
        </div>
        <div>
          <h3>How to stop login using Google, Facebook and Apple ID and remove all your information</h3>
          <ul>
            <li>1. Login to My VNPT, chose Other, then Settings</li>
            <li>2. Click Delete account</li>
            <li>3. Read the term of use carefully before accept and click Continue</li>
            <li>4.Click Delete account to confirm</li>
          </ul>
          If you have linked your account to a mobile number, you only need to remove this link. Please follow these steps:<br />
          <ul>
            <li>1. Login to My VNPT, chose Other, then Settings</li>
            <li>2. Click Delete Google/Facebook/Apple association</li>
            <li>3. Read the term of use carefully before accept and click Continue</li>
            <li>4.Type received OTP then click Continue to confirm</li>
          </ul>
        </div>
      </div>
    );
  }

    return (
        <div id="privacy-policy" className="term-wrapper">
            {/*<div className="term term--privacy">*/}
            <div className="term--privacy">
                <b className="text-center" style={{display: "block"}}>
                    CHÍNH SÁCH BẢO VỆ THÔNG TIN KHÁCH HÀNG<br/>CỦA TẬP ĐOÀN BƯU CHÍNH VIỄN THÔNG VIỆT NAM
                </b>
                <br/>
                <br/>
                <p className="fw-semibold">Căn cứ</p>
                <p className="title-tree">
                    <div>-</div>
                    <div>Luật Bảo vệ dữ liệu cá nhân số 91/2025/QH15 do Quốc hội ban hành ngày 26/6/2025;</div>
                </p>
                <p className="title-tree">
                    <div>-</div>
                    <div>Luật Bảo vệ quyền lợi người tiêu dùng số 19/2023/QH15 do Quốc hội ban hành ngày 20/06/2023;</div>
                </p>
                <p className="title-tree">
                    <div>-</div>
                    <div>Luật Viễn thông số 24/2023/QH15 do Quốc hội ban hành ngày 24/11/2023 và các văn bản hướng dẫn thi hành;</div>
                </p>
                <p className="title-tree">
                    <div>-</div>
                    <div>Nghị định số 356/2025/NĐ-CP do Chính phủ ban hành ngày 31/12/2025 quy định chi tiết một số điều và biện pháp thi hành Luật Bảo vệ dữ liệu cá nhân;</div>
                </p>
                <p className="title-tree">
                    <div>-</div>
                    <div>Nghị định số 163/2024/NĐ-CP do Chính phủ ban hành ngày 24/12/2024 quy định chi tiết một số điều và biện pháp thi hành Luật viễn thông;</div>
                </p>
                <p className="title-tree">
                    <div>-</div>
                    <div>Nghị định số 55/2024/NĐ-CP do Chính phủ ban hành ngày 16/05/2024 quy định chi tiết một số điều của Luật bảo vệ quyền lợi người tiêu dùng;</div>
                </p>
                <p className="title-tree">
                    <div>-</div>
                    <div>Nghị định số 06/2016/NĐ-CP do Chính phủ ban hành ngày 18/01/2016 quy định quản lý, cung cấp và sử dụng dịch vụ phát thanh, truyền hình sửa đổi bổ sung bởi Nghị định 71/2022/NĐ-CP;</div>
                </p>
                <p className="title-tree">
                    <div>-</div>
                    <div>Thông tư số 42/2025/TT-BCT do Bộ trưởng Bộ Công thương ban hành ngày 22/6/2025 Danh mục sản phẩm, hàng hóa, dịch vụ phải đăng ký hợp đồng theo mẫu, điều kiện giao dịch chung.</div>
                </p>

                <p>Chính sách bảo vệ thông tin khách hàng của Tập đoàn Bưu chính Viễn thông Việt Nam (sau đây gọi tắt
                    là <b>“Chính sách”</b>) nhằm mục đích thông báo với Khách hàng về các Thông tin Khách hàng do Tập
                    đoàn Bưu chính Viễn thông Việt Nam (<b>“VNPT”</b>) xử lý, mục đích xử lý, loại thông tin được xử lý,
                    quyền, nghĩa vụ của Khách hàng đối với Thông tin Khách hàng theo quy định của pháp luật Việt Nam về
                    bảo vệ Thông tin Khách hàng. Chính sách này đồng thời đưa ra các khuyến nghị để giúp Khách hàng nâng
                    cao nhận thức về bảo vệ Thông tin Khách hàng.</p>
                <p>Chính sách này là cam kết chung được áp dụng cho toàn bộ hoạt động cung cấp Sản phẩm, dịch vụ của
                    VNPT và áp dụng trên toàn bộ các kênh tương tác với Khách hàng.</p>
                <p>VNPT có trách nhiệm cung cấp đầy đủ Chính sách này cho khách hàng trước khi ký hợp đồng hoặc giao
                    dịch và lấy chấp thuận của Khách hàng đối với Chính sách này trước khi thực hiện hoạt động xử lý
                    Thông tin Khách hàng theo quy định của pháp luật. Bằng việc tích vào ô "Chấp thuận" trên các website
                    (trang mạng)/ứng dụng cung cấp dịch vụ của VNPT có đăng tải công khai Chính sách này; hoặc bằng việc
                    ký kết hợp đồng với VNPT có dẫn chiếu và đính kèm Chính sách này; hoặc bằng các cách thức khác lấy
                    sự đồng ý của Khách hàng được VNPT triển khai theo từng thời kỳ; Khách hàng xác nhận rằng đã đọc kỹ,
                    hiểu rõ và chấp thuận Chính sách này.</p>

                <h3>Điều 1. Giải thích từ ngữ và các từ viết tắt</h3>
                <p>Trong phạm vi Chính sách này, các thuật ngữ dưới đây được hiểu và giải thích như sau:</p>
                <div className="title-tree">
                    <div>1.</div>
                    <div><b>VNPT</b> là Tập Đoàn Bưu Chính Viễn Thông Việt Nam và các đơn vị trực thuộc Tập Đoàn Bưu Chính Viễn Thông Việt Nam.</div>
                </div>
                {/*<div className="title-tree">*/}
                {/*    <div>1.2.</div>*/}
                {/*    <div>Công ty con của VNPT là các doanh nghiệp do VNPT sở hữu 100% vốn điều lệ. Công ty con của*/}
                {/*        VNPT bao gồm Tổng công ty Dịch vụ Viễn thông (VNPT VinaPhone) và Tổng công ty Truyền thông*/}
                {/*        (VNPT Media).*/}
                {/*    </div>*/}
                {/*</div>*/}
                <div className="title-tree">
                    <div>2.</div>
                    <div><b>Khách hàng</b> là:
                        Cá nhân hoặc người đại diện hợp pháp của cá nhân, tổ chức cung cấp Thông tin Khách hàng cho VNPT
                        khi tìm kiếm, tiếp cận, mua, đăng ký sử dụng, sử dụng sản phẩm, dịch vụ của VNPT.
                        {/*<div className="title-tree">*/}
                        {/*    <div>-</div>*/}
                        {/*    <div>Cá nhân hoặc người đại diện hợp pháp của cá nhân, tổ chức cung cấp Thông tin Khách hàng cho VNPT khi tìm kiếm, tiếp cận, mua, đăng ký sử dụng, sử dụng sản phẩm, dịch vụ của VNPT.</div>*/}
                        {/*</div>*/}
                    </div>
                </div>
                <div className="title-tree">
                    <div>3.</div>
                    <div><b>Sản phẩm, dịch vụ của VNPT </b>là: Bất kỳ sản phẩm, dịch vụ nào do VNPT cung cấp và/hoặc do
                        VNPT hợp tác với đối tác mà Khách hàng tìm kiếm, tiếp cận, mua, đăng ký sử dụng, sử dụng.
                        {/*<div className="title-tree">*/}
                        {/*    <div>-</div>*/}
                        {/*    <div>Bất kỳ sản phẩm, dịch vụ nào do VNPT cung cấp và/hoặc do VNPT hợp tác với đối tác mà Khách hàng tìm kiếm, tiếp cận, mua, đăng ký sử dụng, sử dụng.</div>*/}
                        {/*</div>*/}
                    </div>
                </div>
                <div className="title-tree">
                    <div>4.</div>
                    <div><b>Thông tin Khách hàng</b> bao gồm (i) Dữ liệu cá nhân theo quy định của pháp luật về bảo vệ
                        dữ liệu cá nhân và (ii) Thông tin về quá trình mua, sử dụng sản phẩm, dịch vụ của Khách hàng và
                        thông tin khác liên quan đến giao dịch giữa Khách hàng và VNPT.
                        {/*<div className="title-tree">*/}
                        {/*    <div></div>*/}
                        {/*    <div>(i) Dữ liệu cá nhân của Khách hàng theo quy định của pháp luật về bảo vệ dữ liệu cá*/}
                        {/*        nhân;*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        {/*<div className="title-tree">*/}
                        {/*    <div></div>*/}
                        {/*    <div>(ii) Thông tin về quá trình mua, sử dụng sản phẩm, hàng hóa, dịch vụ của Khách hàng*/}
                        {/*        và thông tin khác liên quan đến giao dịch giữa Khách hàng và VNPT VinaPhone.*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                    </div>
                </div>
                <br/>


                <h3>Điều 2. Xử lý Thông tin Khách hàng</h3>
                <div className="title-tree">
                    <div>1.</div>
                    <div>
                        <p>VNPT có trách nhiệm thông báo Chính sách này cho Khách hàng và lấy chấp thuận của Khách hàng trước khi tiến hành xử lý Thông tin Khách hàng, Thông tin Khách hàng được thu thập và xử lý từ các nguồn dưới đây:</p>
                        <p className="title-tree">a) Khi Khách hàng hoặc người đại diện hợp pháp của Khách hàng liên hệ
                            với VNPT để yêu cầu tư vấn Sản phẩm, dịch vụ của VNPT hoặc bày tỏ sự quan tâm tới các Sản
                            phẩm, dịch vụ của VNPT;</p>
                        <p className="title-tree">b) Khi Khách hàng dùng thử, ký kết hợp đồng, đăng ký, sử dụng Sản
                            phẩm, dịch vụ của VNPT;</p>
                        <p className="title-tree">c) Khi Khách hàng truy cập và/hoặc đăng ký tài khoản tại các
                            website/ứng dụng cung cấp dịch vụ của VNPT;</p>
                        <p className="title-tree">d) Khi Khách hàng đồng thuận cung cấp Thông tin Khách hàng cho VNPT
                            qua các nguồn như: website/ứng dụng cung cấp dịch vụ; cuộc họp, sự kiện, hội thảo, hội nghị,
                            các mạng xã hội, hay chương trình đối thoại, thảo luận, khảo sát do VNPT tổ chức, tài trợ
                            hoặc tham dự và/hoặc từ các tệp lưu trữ (cookies) ghi nhận được trên website/ứng dụng cung
                            cấp dịch vụ của VNPT, qua trao đổi, liên lạc với VNPT (qua thư, điện thoại, trực tuyến, hệ
                            thống tổng đài hoặc các hình thức khác).</p>
                        <p className="title-tree">e) Khi khách hàng của một tổ chức, doanh nghiệp cho phép tổ chức,
                            doanh nghiệp đó chia sẻ Thông tin Khách hàng với VNPT;</p>
                        <p className="title-tree">f) Là khách hàng của một tổ chức, doanh nghiệp được VNPT thực hiện góp
                            vốn, mua cổ phần; hoặc là khách hàng của một tổ chức, doanh nghiệp có hoạt động hợp tác cung
                            cấp sản phẩm, dịch vụ với VNPT.</p>
                        <p className="title-tree">g) Khi có yêu cầu của các cơ quan nhà nước có thẩm quyền.</p>
                        <p className="title-tree">h) Khi VNPT tiến hành các công việc theo mục đích xử lý Thông tin
                            Khách hàng được quy định tại Điều 3 Chính sách này.</p>
                        <p className="title-tree">i) Các trường hợp khác theo quy định của pháp luật.</p>
                    </div>
                </div>
                <div className="title-tree">
                    <div>2.</div>
                    <div>
                        Dữ liệu cá nhân của Khách hàng được VNPT tiến hành xử lý (sau đây gọi tắt là <b>“Dữ liệu cá nhân”</b>) bao gồm:
                        <p>
                            <div className="title-tree">
                                {/*<div>▪</div>*/}
                                <div>a) Họ, chữ đệm và tên khai sinh, tên gọi khác (nếu có);</div>
                            </div>
                            <div className="title-tree">
                                {/*<div>▪</div>*/}
                                <div>b) Ngày, tháng, năm sinh; ngày, tháng, năm chết hoặc mất tích;</div>
                            </div>
                            <div className="title-tree">
                                {/*<div>▪</div>*/}
                                <div>c) Giới tính;</div>
                            </div>
                            <div className="title-tree">
                                {/*<div>▪</div>*/}
                                <div>d) Nơi sinh, nơi đăng ký khai sinh, nơi đăng ký thường trú, nơi đăng ký tạm trú, nơi ở hiện tại, quê quán, địa chỉ liên hệ;</div>
                            </div>
                            <div className="title-tree">
                                {/*<div>▪</div>*/}
                                <div>e) Quốc tịch;</div>
                            </div>
                            <div className="title-tree">
                                {/*<div>▪</div>*/}
                                <div>f) Hình ảnh của cá nhân;</div>
                            </div>
                            <div className="title-tree">
                                {/*<div>▪</div>*/}
                                <div>g) Số điện thoại, số định danh cá nhân, số hộ chiếu, số giấy phép lái xe, số
                                    biển số xe;
                                </div>
                            </div>
                            <div className="title-tree">
                                {/*<div>▪</div>*/}
                                <div>h) Thông tin về mối quan hệ gia đình (cha mẹ, con, vợ, chồng);</div>
                            </div>
                            <div className="title-tree">
                                {/*<div>▪</div>*/}
                                <div>i) Thông tin về tài khoản số của cá nhân, thông tin phát sinh trong quá trình sử dụng sản phẩm, dịch vụ;</div>
                            </div>
                            <div className="title-tree">
                                {/*<div>▪</div>*/}
                                <div>j) Thông tin địa chỉ IP, dữ liệu cookies mang tính định danh, thông tin định danh thiết bị;</div>
                            </div>
                            <div className="title-tree">
                                {/*<div>▪</div>*/}
                                <div>k) Các thông tin khác gắn liền với một con người cụ thể hoặc giúp xác định một con người cụ thể;</div>
                            </div>
                            <div className="title-tree">
                                <div>l) Dữ liệu sinh trắc học, đặc điểm di truyền;</div>
                            </div>
                            <div className="title-tree">
                                <div>n) Thông tin tên đăng nhập và mật khẩu truy cập tài khoản định danh điện tử của cá nhân; hình ảnh thẻ căn cước, thẻ căn cước công dân, chứng minh nhân dân;</div>
                            </div>
                            <div className="title-tree">
                                <div>m) Thông tin tài khoản viễn thông của Khách hàng;</div>
                            </div>
                            <div className="title-tree">
                                <div>o) Tên đăng nhập, mật khẩu truy cập của tài khoản ngân hàng; thông tin thẻ ngân hàng, dữ liệu về lịch sử giao dịch của tài khoản ngân hàng; thông tin tài chính, tín dụng và các thông tin về hoạt động, lịch sử giao dịch tài chính của khách hàng sử dụng dịch vụ trung gian thanh toán;</div>
                            </div>
                            <div className="title-tree">
                                <div>p) Dữ liệu theo dõi hành vi, hoạt động sử dụng dịch vụ viễn thông, mạng xã hội, dịch vụ truyền thông trực tuyến và các dịch vụ khác trên không gian mạng;</div>
                            </div>
                            <div className="title-tree">
                                <div>q) Dữ liệu về vị trí của cá nhân được xác định qua dịch vụ định vị</div>
                            </div>
                            <div className="title-tree">
                                <div>r) Dữ liệu cá nhân khác được pháp luật quy định là cần giữ bí mật hoặc cần có biện pháp bảo mật chặt chẽ.</div>
                            </div>
                        </p>

                        {/*<p className="title-tree">*/}
                        {/*    <div>2.2.</div>*/}
                        {/*    <div>*/}
                        {/*        <div>Dữ liệu cá nhân nhạy cảm</div>*/}
                        {/*        <div className="title-tree">*/}
                        {/*            /!*<div>▪</div>*!/*/}
                        {/*            <div>a) Dữ liệu sinh trắc học, đặc điểm di truyền;</div>*/}
                        {/*        </div>*/}
                        {/*        <div className="title-tree">*/}
                        {/*            /!*<div>▪</div>*!/*/}
                        {/*            <div>b) Thông tin tên đăng nhập và mật khẩu truy cập tài khoản định danh điện tử của*/}
                        {/*                cá nhân; hình ảnh thẻ căn cước, thẻ căn cước công dân, chứng minh nhân dân;*/}
                        {/*            </div>*/}
                        {/*        </div>*/}
                        {/*        <div className="title-tree">*/}
                        {/*            /!*<div>▪</div>*!/*/}
                        {/*            <div>c) Thông tin tài khoản viễn thông của Khách hàng;</div>*/}
                        {/*        </div>*/}
                        {/*        <div className="title-tree">*/}
                        {/*            /!*<div>▪</div>*!/*/}
                        {/*            <div>d) Tên đăng nhập, mật khẩu truy cập của tài khoản ngân hàng; thông tin thẻ ngân*/}
                        {/*                hàng, dữ liệu về lịch sử giao dịch của tài khoản ngân hàng; thông tin tài chính,*/}
                        {/*                tín dụng và các thông tin về hoạt động, lịch sử giao dịch tài chính của khách*/}
                        {/*                hàng sử dụng dịch vụ trung gian thanh toán;*/}
                        {/*            </div>*/}
                        {/*        </div>*/}
                        {/*        <div className="title-tree">*/}
                        {/*            /!*<div>▪</div>*!/*/}
                        {/*            <div>e) Dữ liệu theo dõi hành vi, hoạt động sử dụng dịch vụ viễn thông, mạng xã hội,*/}
                        {/*                dịch vụ truyền thông trực tuyến và các dịch vụ khác trên không gian mạng;*/}
                        {/*            </div>*/}
                        {/*        </div>*/}
                        {/*        <div className="title-tree">*/}
                        {/*            /!*<div>▪</div>*!/*/}
                        {/*            <div>f) Dữ liệu về vị trí của cá nhân được xác định qua dịch vụ định vị.</div>*/}
                        {/*        </div>*/}
                        {/*        <div className="title-tree">*/}
                        {/*            /!*<div>▪</div>*!/*/}
                        {/*            <div>g) Dữ liệu cá nhân khác được pháp luật quy định là cần giữ bí mật hoặc cần có*/}
                        {/*                biện pháp bảo mật chặt chẽ.*/}
                        {/*            </div>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*</p>*/}
                    </div>
                </div>
                <div className="title-tree">
                    <div>3.</div>
                    <div>Các dữ liệu được quy định tại khoản 2 điều này được thu thập để phục vụ cho mục đích cung cấp dịch vụ cho Khách hàng.</div>
                </div>
                <div className="title-tree">
                    <div>4.</div>
                    <div>Khách hàng được quyền lựa chọn quyền cung cấp hoặc không cung cấp khi thu thập thông tin sử dụng dịch vụ theo thỏa thuận tại Hợp đồng cung cấp dịch vụ.</div>
                </div>
                <div className="title-tree">
                    <div>5.</div>
                    <div>
                        VNPT sẽ thông báo cho Khách hàng các Thông tin Khách hàng bắt buộc phải cung cấp (<b>“Thông tin Khách hàng bắt buộc cung cấp”</b>) và các Thông tin Khách hàng được lựa chọn đồng ý hoặc không đồng ý cung cấp (<b>“Thông tin Khách hàng tùy chọn cung cấp”</b>) tại thời điểm Khách hàng liên hệ, trao đổi hoặc đăng ký, ký kết hợp đồng với VNPT. Trong đó, Thông tin Khách hàng bắt buộc phải cung cấp được hiểu là các Thông tin Khách hàng mà VNPT cần phải thu thập từ Khách hàng theo quy định của pháp luật hoặc các Thông tin Khách hàng mà VNPT bắt buộc phải sử dụng để triển khai cung cấp một phần hoặc toàn bộ Sản phẩm, dịch vụ của VNPT theo yêu cầu của Khách hàng. Thông tin Khách hàng tùy chọn cung cấp được hiểu là các Thông tin Khách hàng mà VNPT thu thập để nâng cao trải nghiệm khách hàng, dự đoán hành vi tiêu dùng hoặc nghiên cứu thị trường dịch vụ, việc không cung cấp Thông tin Khách hàng tùy chọn cung cấp không làm ảnh hưởng tới việc cung cấp Sản phẩm, dịch vụ của VNPT theo yêu cầu của Khách hàng.
                        <br/>
                        Trong trường hợp Khách hàng không cung cấp đầy đủ các Thông tin Khách hàng bắt buộc phải cung cấp, Khách hàng sẽ không thể sử dụng Sản phẩm, dịch vụ của VNPT. Trong trường hợp này, VNPT có thể từ chối cung cấp sản phẩm, dịch vụ cho Khách hàng mà không phải chịu bất kì một khoản bồi thường và/hoặc phạt vi phạm nào (trừ trường hợp do lỗi của VNPT hoặc pháp luật có quy định khác).
                    </div>
                </div>
                <div className="title-tree">
                    <div>6.</div>
                    <div>VNPT có thể tự mình hoặc ủy quyền, thuê bên thứ ba thực hiện xử lý Thông tin Khách hàng với điều kiện là việc xử lý Thông tin Khách hàng phải bảo đảm an toàn, an ninh Thông tin Khách hàng theo quy định của pháp luật. Trường hợp VNPT ủy quyền hoặc thuê bên thứ ba thực hiện việc xử lý Thông tin Khách hàng thì phải được sự đồng ý của Khách hàng ngoại trừ các trường hợp được quy định tại khoản 1 Điều 4 Chính sách này. Việc ủy quyền hoặc thuê bên thứ ba phải được thực hiện bằng văn bản, trong đó quy định rõ phạm vi, trách nhiệm của mỗi bên trong việc bảo vệ Thông tin Khách hàng theo quy định của pháp luật. Trường hợp Khách hàng thực hiện giao dịch thông qua bên thứ ba thì bên thứ ba có trách nhiệm bảo vệ Thông tin Khách hàng theo quy định của pháp luật.</div>
                </div>


                <br/>
                <h3>Điều 3. Mục đích xử lý Thông tin Khách hàng</h3>
                <p>1. VNPT được phép tiến hành xử lý Thông tin Khách hàng trong các trường hợp sau (“<b>Mục đích bắt buộc</b>”):</p>
                <div className="title-tree">
                    {/*<div>●</div>*/}
                    <div>
                        <p>a) Cung cấp sản phẩm, dịch vụ của VNPT theo yêu cầu của Khách hàng và chỉ trong phạm vi thông tin mà Khách hàng đã đồng ý (<i>Theo Điểm b Khoản 3 Điều 18 Luật bảo vệ quyền lợi người tiêu dùng 2023</i>), bao gồm:</p>
                        <p className="title-tree">
                            {/*<div>○</div>*/}
                            <div>- Xác minh tính chính xác, đầy đủ của các thông tin được Khách hàng cung cấp theo quy
                                định của pháp luật; xác định hoặc xác thực danh tính của Khách hàng và thực hiện quy
                                trình xác thực Khách hàng; Xử lý việc đăng ký sử dụng Sản phẩm, dịch vụ của VNPT;
                            </div>
                        </p>
                        <p className="title-tree">
                            {/*<div>○</div>*/}
                            <div>- Thẩm định hồ sơ và khả năng đủ điều kiện của Khách hàng đối với việc sử dụng Sản phẩm, dịch vụ của VNPT. VNPT có thể sử dụng các phương pháp chấm điểm, gán ngưỡng cước nóng, kiểm tra lịch sử Khách hàng sử dụng Sản phẩm, dịch vụ của VNPT để đánh giá và quản trị rủi ro tín dụng, đảm bảo khả năng thanh toán đối với các nghĩa vụ thanh toán và các nghĩa vụ khác có liên quan trong suốt quá trình cung cấp Sản phẩm, dịch vụ của VNPT cho Khách hàng;</div>
                        </p>
                        <p className="title-tree">
                            {/*<div>○</div>*/}
                            <div>- Thực hiện các quyền, nghĩa vụ của Khách hàng theo quy định pháp luật, theo quy định
                                của hợp đồng giữa Khách hàng và VNPT.
                            </div>
                        </p>
                        <p className="title-tree">
                            {/*<div>○</div>*/}
                            <div>- Thông báo tới Khách hàng thông tin về kế hoạch tác động mạng lưới liên quan đến Sản
                                phẩm, dịch vụ của VNPT.
                            </div>
                        </p>
                        <p className="title-tree">
                            {/*<div>○</div>*/}
                            <div>- Quản lý tài khoản Khách hàng và các chương trình Khách hàng thân thiết;</div>
                        </p>
                        <p className="title-tree">
                            {/*<div>○</div>*/}
                            <div>- Tiếp nhận giải quyết các yêu cầu, khiếu nại, khiếu kiện của Khách hàng; gửi các thông
                                báo cho Khách hàng nhằm khảo sát sự hài lòng của Khách hàng đối với chất lượng sản phẩm,
                                dịch vụ, quy trình giải quyết yêu cầu, khiếu nại, khiếu kiện do VNPT thực hiện;
                            </div>
                        </p>
                        <p className="title-tree">
                            {/*<div>○</div>*/}
                            <div>- Liên hệ với Khách hàng nhằm tư vấn, trao đổi thông tin, giải quyết yêu cầu, khiếu
                                nại, giao các hóa đơn, các sao kê, các báo cáo hoặc các tài liệu khác liên quan tới Sản
                                phẩm, dịch vụ của VNPT thông qua các kênh khác nhau (ví dụ: email, chat) và để trả lời
                                yêu cầu của Khách hàng. Liên hệ với Khách hàng (hoặc các bên do Khách hàng chỉ định hoặc
                                yêu cầu) để thông báo cho Khách hàng về thông tin liên quan đến việc sử dụng Sản phẩm,
                                dịch vụ của VNPT.
                            </div>
                        </p>
                        <p className="title-tree">
                            {/*<div>○</div>*/}
                            <div>- Đánh giá hiệu quả sản xuất kinh doanh của các đơn vị; vận hành hệ thống quản trị nội
                                bộ, hệ thống đánh giá hiệu quả công việc và các hệ thống giám sát hoạt động sản xuất
                                kinh doanh;
                            </div>
                        </p>
                        <p className="title-tree">
                            {/*<div>○</div>*/}
                            <div>- Lập hồ sơ phục vụ công tác mời thầu hoặc tham dự thầu hoặc; Lập báo cáo, thống kê,
                                phân tích dữ liệu nội bộ để nghiên cứu, xây dựng, phát triển, quản lý, đo lường, cung
                                cấp và cải tiến Sản phẩm, hàng hóa, dịch vụ cũng như điều hành hoạt động kinh doanh của
                                VNPT;
                            </div>
                        </p>
                        <p className="title-tree">
                            {/*<div>○</div>*/}
                            <div>- Đánh giá khả năng mua, sử dụng sản phẩm, hàng hóa, dịch vụ của VNPT thông qua điểm
                                xếp hạng viễn thông của Khách hàng nhằm hỗ trợ tốt nhất trong việc cung cấp các sản
                                phẩm, hàng hóa, dịch vụ cho Khách hàng;
                            </div>
                        </p>
                        <p className="title-tree">
                            {/*<div>○</div>*/}
                            <div>- Cung cấp thông tin mà Khách hàng yêu cầu hoặc nhận định rằng Khách hàng có thể thấy
                                hữu ích, bao gồm thông tin về các Sản phẩm, dịch vụ của VNPT theo quy định pháp luật;
                            </div>
                        </p>
                        <p className="title-tree">
                            {/*<div>○</div>*/}
                            <div>- Cải tiến công nghệ, giao diện website/ứng dụng cung cấp dịch vụ đảm bảo tối ưu hóa
                                trải nghiệm của Khách hàng;
                            </div>
                        </p>
                        <p className="title-tree">
                            <div>- Phát hiện, ngăn chặn các hành vi gian lận, lừa đảo, tấn công, xâm nhập, chiếm đoạt
                                trái phép, và các hành vi vi phạm quy định pháp luật khác;
                            </div>
                        </p>
                    </div>
                </div>
                <div className="title-tree">
                    {/*<div>●</div>*/}
                    <div>
                        <p>b) Thực hiện các nghĩa vụ theo quy định của pháp luật (<i>Theo Điểm c Khoản 3 Điều 18 Luật bảo vệ quyền lợi người tiêu dùng 2023</i>), bao gồm:</p>
                        <p className="title-tree">
                            {/*<div>○</div>*/}
                            <div>- Để thực hiện các nghĩa vụ của VNPT theo quy định của pháp luật và theo yêu cầu của cơ
                                quan nhà nước có thẩm quyền như: thanh tra, kiểm tra, kiểm toán, báo cáo, tài chính, kế
                                toán và thuế, quản lý rủi ro, phòng chống rửa tiền, tài trợ khủng bố...
                            </div>
                        </p>
                        <p className="title-tree">
                            {/*<div>○</div>*/}
                            <div>- Phát hiện, ngăn chặn các hành vi vi phạm pháp luật theo yêu cầu của cơ quan quản lý
                                nhà nước có thẩm quyền và/hoặc theo quy định của pháp luật;
                            </div>
                        </p>
                        <p className="title-tree">
                            {/*<div>○</div>*/}
                            <div>- Trong trường hợp cần xử lý ngay Thông tin khách hàng có liên quan để bảo vệ tính
                                mạng, sức khỏe, danh dự, nhân phẩm, quyền, lợi ích hợp pháp của chủ thể dữ liệu cá nhân
                                hoặc người khác trong trường hợp cấp bách; bảo vệ quyền hoặc lợi ích chính đáng của
                                mình, của người khác hoặc lợi ích của Nhà nước, của cơ quan tổ chức một cách cần thiết
                                trước hành vi xâm phạm lợi ích nói trên;
                            </div>
                        </p>
                        <p className="title-tree">
                            {/*<div>○</div>*/}
                            <div>- Giải quyết tình trạng khẩn cấp; nguy cơ đe dọa an ninh quốc gia nhưng chưa đến mức
                                ban bố tình trạng khẩn cấp; phòng, chống bạo loạn, khủng bố, phòng, chống tội phạm và vi
                                phạm pháp luật;
                            </div>
                        </p>
                        <p className="title-tree">
                            {/*<div>○</div>*/}
                            <div>- Phục vụ hoạt động của cơ quan nhà nước, hoạt động quản lý nhà nước theo quy định của
                                pháp luật;
                            </div>
                        </p>
                        <p className="title-tree">
                            {/*<div>○</div>*/}
                            <div>- Thực hiện thỏa thuận của chủ thể dữ liệu cá nhân với cơ quan, tổ chức, cá nhân có
                                liên quan theo quy định của pháp luật;
                            </div>
                        </p>
                        <p className="title-tree">
                            {/*<div>○</div>*/}
                            <div>- Việc công khai Thông tin Khách hàng theo quy định của luật; tuân thủ các nghĩa vụ của
                                doanh nghiệp cung cấp dịch vụ viễn thông, truyền hình, trung gian thanh toán, tiền di
                                động theo quy định của pháp luật.
                            </div>
                        </p>
                    </div>
                </div>

                <p>2. Trừ trường hợp quy định tại khoản 1 Điều này, VNPT phải thực hiện thông báo và lấy chấp thuận của Khách hàng trước khi xử lý Thông tin Khách hàng của Khách hàng đối với các mục đích được liệt kê dưới đây (sau đây gọi tắt là “<b>Mục đích tùy chọn</b>”). Thông tin Khách hàng thu thập, cập nhật, bổ sung phải phù hợp và giới hạn trong phạm vi, mục đích cần xử lý theo quy định tại Chính sách này.</p>
                <p className="title-tree">
                    {/*<div>●</div>*/}
                    <div>a) Mục đích kinh doanh các dịch vụ xử lý dữ liệu cá nhân (bao gồm nhưng không hạn chế: chấm
                        điểm, xếp hạng tín dụng, đánh giá thông tin tín dụng, đánh giá mức độ tín nhiệm về tín dụng…),
                        các sản phẩm, dịch vụ dữ liệu; dịch vụ xác thực, dịch vụ định danh.
                    </div>
                </p>
                <p className="title-tree">
                    {/*<div>●</div>*/}
                    <div>b) Mục đích kinh doanh các dịch vụ quảng cáo, dịch vụ tiếp thị, nghiên cứu thị trường, thăm dò dư luận, môi giới. Đối với dịch vụ tiếp thị, phương thức, hình thức, tần suất giới thiệu sản phẩm thực hiện theo quy định của pháp luật về bảo vệ dữ liệu cá nhân.</div>
                </p>
                <p className="title-tree">
                    {/*<div>●</div>*/}
                    <div>c) Sử dụng dữ liệu cá nhân của khách hàng để nghiên cứu, phát triển các thuật toán tự học, hệ
                        thống trí tuệ nhân tạo, các hệ thống tự động khác và/hoặc xử lý dữ liệu cá nhân trong công nghệ
                        chuỗi khối, trí tuệ nhân tạo, xử lý dữ liệu lớn để nghiên cứu, phát triển các sản phẩm, dịch vụ
                        hoặc ứng dụng, hệ thống.
                    </div>
                </p>
                <p className="title-tree">
                    {/*<div>●</div>*/}
                    <div>d) Tổ chức chương trình quảng cáo, giới thiệu sản phẩm, hàng hóa, dịch vụ và thực hiện các hoạt
                        động xúc tiến thương mại đối với sản phẩm, hàng hóa, dịch vụ do VNPT cung cấp cho Khách hàng,
                        bao gồm các hoạt động sử dụng Thông tin Khách hàng để quảng cáo, tiếp thị với Khách hàng về các
                        chương trình khuyến mại, nghiên cứu, khảo sát, tin tức, thông tin cập nhật, các sự kiện, cuộc
                        thi có thưởng, trao các phần thưởng có liên quan, các quảng cáo và nội dung có liên quan về Sản
                        phẩm, dịch vụ của VNPT. Trường hợp Khách hàng không muốn tiếp tục nhận email, tin nhắn và/hoặc
                        bản tin định kỳ với mục đích quảng cáo, tiếp thị của VNPT với tần suất tùy thuộc vào Chính sách
                        của VNPT theo từng thời kỳ và phù hợp với quy định pháp luật, Khách hàng có thể từ chối theo
                        cách thức đã được VNPT hướng dẫn trên các kênh, phương tiện như tin nhắn, cuộc gọi, dấu tích
                        trên website/ứng dụng cung cấp dịch vụ hoặc liên hệ với tổng đài chăm sóc Khách hàng của VNPT;
                    </div>
                </p>
                <p>3. VNPT không thực hiện hoạt động mua bán Thông tin Khách hàng dưới bất kỳ hình thức nào.</p>


                <h3>Điều 4. Phạm vi sử dụng Thông tin Khách hàng</h3>
                <div>1. VNPT được phép chia sẻ Thông tin Khách hàng của Khách hàng cho các tổ chức, cá nhân dưới đây để thực hiện các Mục Đích quy định tại Chính sách (<b>“Phạm vi sử dụng bắt buộc”</b>), cụ thể:</div>
                <div className="title-tree">
                    <div>a)</div>
                    <div>Chia sẻ thông tin với Bên thứ ba cung cấp dịch vụ cho VNPT hoặc các đối tác trong các hợp đồng hợp tác kinh doanh nhằm phát triển sản phẩm, dịch vụ của VNPT và hai bên đã có thỏa thuận bằng văn bản về việc bên thứ ba có trách nhiệm bảo vệ Thông tin Khách hàng (<i>Theo Điểm a Khoản 4 Điều 18 Luật bảo vệ quyền lợi người tiêu dùng 2023</i>). Các Bên thứ ba cung cấp dịch vụ và/hoặc các đối tác này có quyền truy cập, thu thập, sử dụng và xử lý Thông tin Khách hàng của Khách hàng trong phạm vi Khách hàng đã đồng ý và VNPT cho phép để thực hiện các chức năng của họ và phải tuân thủ quy định của pháp luật về bảo vệ Thông tin Khách hàng với tư cách là Bên Xử lý Dữ Liệu, có văn bản/thỏa thuận về xử lý Thông tin Khách hàng xác định rõ phạm vi, mục đích, loại Thông tin Khách hàng được chia sẻ, các quyền nghĩa vụ của các bên và trách nhiệm của Bên Xử lý Thông tin Khách hàng đối với việc bảo vệ Thông tin Khách hàng.</div>
                </div>
                <div className="title-tree">
                    <div>b)</div>
                    <div>Chia sẻ thông tin với các doanh nghiệp viễn thông có thỏa thuận bằng văn bản với VNPT về việc trao đổi, cung cấp thông tin thuê bao viễn thông, thông tin về việc sử dụng dịch vụ viễn thông của người sử dụng dịch vụ để phục vụ cho việc tính giá, lập hóa đơn (<i>Theo quy định tại Điểm b Khoản 4 Điều 6 Luật Viễn thông 2023</i>);</div>
                </div>
                <div className="title-tree">
                    <div>c)</div>
                    <div>Cung cấp thông tin thuê bao viễn thông có hành vi trốn tránh thực hiện nghĩa vụ thanh toán tiền sử dụng dịch vụ viễn thông theo quy định của pháp luật (<i>Theo quy định tại Điểm c Khoản 4 Điều 6 Luật Viễn thông 2023</i>);</div>
                </div>
                <div className="title-tree">
                    <div>d)</div>
                    <div>Khi có yêu cầu của cơ quan nhà nước có thẩm quyền theo quy định của pháp luật.</div>
                </div>
                <div>2. Ngoài các đối tượng quy định tại khoản 1 Điều này, việc chia sẻ Thông tin Khách hàng cho bất kì bên thứ ba nào khác phải được sự chấp thuận của Khách hàng (<b>“Phạm vi sử dụng tùy chọn”</b>).</div>
                <br/>


                <h3>Điều 5. Quyền của Khách hàng</h3>
                <div className="title-tree">
                    <div>1.</div>
                    <div>
                        Quyền được biết và Quyền đồng ý
                        <br/>
                        Khách hàng có quyền được biết về hoạt động xử lý Thông tin Khách hàng của mình, trừ trường hợp
                        pháp luật có quy định khác.
                        <br/>
                        Khách hàng có quyền đồng ý hoặc không đồng ý với các điều khoản và điều kiện của Chính sách này
                        theo cách thức đã được VNPT hướng dẫn trên các kênh, phương tiện như tin nhắn SMS, cuộc gọi, dấu
                        tích trên website/ứng dụng cung cấp dịch vụ hoặc liên hệ với tổng đài chăm sóc khách hàng của
                        VNPT phù hợp với quy định của pháp luật. VNPT chỉ thực hiện xử lý Thông tin Khách hàng khi đã có
                        chấp thuận của Khách hàng trừ trường hợp pháp luật có quy định khác.
                    </div>
                </div>
                <div className="title-tree">
                    <div>2.</div>
                    <div>
                        Quyền xem và yêu cầu cung cấp Thông tin Khách hàng
                        <br/>
                        Khách hàng có quyền truy cập vào các ứng dụng cung cấp dịch vụ/website của VNPT và/hoặc liên hệ
                        trực tiếp với VNPT để xem, chỉnh sửa, trích xuất các Thông tin Khách hàng của mình, trừ trường
                        hợp pháp luật có quy định khác.
                        <br/>
                        Trường hợp Khách hàng không thể tự truy cập để xem, chỉnh sửa, trích xuất hoặc gặp khó khăn
                        trong việc truy cập để xem, chỉnh sửa hoặc trích xuất các Thông tin Khách hàng, Khách hàng vui
                        lòng liên hệ với VNPT để được hỗ trợ.
                    </div>
                </div>
                <div className="title-tree">
                    <div>3.</div>
                    <div>
                        Quyền chỉnh sửa hoặc yêu cầu chỉnh sửa dữ liệu cá nhân
                        <br/>
                        Khách hàng có quyền xem, chỉnh sửa các Thông tin Khách hàng của mình với điều kiện việc chỉnh
                        sửa này không vi phạm các quy định của pháp luật. Trường hợp Khách hàng không thể tự chỉnh sửa
                        hoặc gặp khó khăn trong việc chỉnh sửa các Thông tin Khách hàng, Khách hàng có thể liên hệ với
                        VNPT để được hỗ trợ.
                    </div>
                </div>
                <div className="title-tree">
                    <div>4.</div>
                    <div>
                        Quyền phản đối, hạn chế, rút lại sự đồng ý xử lý dữ liệu
                        <p className="title-tree">
                            {/*<div>○</div>*/}
                            <div>a) Khách hàng có quyền phản đối, yêu cầu hạn chế xử lý Thông tin Khách hàng hoặc rút
                                lại sự đồng ý xử lý Thông tin Khách hàng khi có nghi ngờ phạm vi, mục đích xử lý dữ liệu
                                cá nhân hoặc tính chính xác của dữ liệu cá nhân, trừ trường hợp pháp luật có quy định
                                khác. Tuy nhiên, việc phản đối, hạn chế hoặc rút lại sự đồng ý xử lý Thông tin Khách
                                hàng bắt buộc cung cấp tại Điều 2 hoặc phản đối, hạn chế hoặc rút lại sự đồng ý xử lý
                                Thông tin Khách hàng phục vụ các Mục đích bắt buộc quy định tại khoản 1 Điều 3 Chính
                                sách này hoặc phản đối, hạn chế hoặc rút lại sự đồng ý đối với Phạm vi sử dụng bắt buộc
                                tại khoản 1 Điều 4 Chính sách này sẽ dẫn tới việc VNPT không thể cung cấp Sản phẩm, dịch
                                vụ cho Khách hàng, điều này đồng nghĩa với việc VNPT có thể xem xét dừng cung cấp dịch
                                vụ cho Khách hàng hoặc đơn phương chấm dứt hợp đồng mà không cần phải bồi thường cho
                                Khách hàng do các điều kiện để thực hiện hợp đồng đã thay đổi (trừ trường hợp do lỗi của
                                VNPT).
                            </div>
                        </p>
                        <p className="title-tree">
                            {/*<div>○</div>*/}
                            <div>b) Trường hợp Khách hàng muốn phản đối, hạn chế, rút lại sự đồng ý xử lý Thông tin
                                Khách hàng phục vụ các Mục đích tùy chọn quy định tại khoản 2 Điều 3 Chính sách này hoặc
                                phản đối, hạn chế, rút lại sự đồng ý xử lý Thông tin Khách hàng tùy chọn cung cấp hoặc
                                phản đối, hạn chế, rút lại sự đồng ý xử lý đối với Phạm vi sử dụng tùy chọn quy định tại
                                khoản 2 Điều 4, Khách hàng thực hiện theo hướng dẫn của VNPT tại thời điểm VNPT thu thập
                                Thông tin Khách hàng hoặc liên hệ với VNPT theo các thông tin được cung cấp tại Chính
                                sách này. Nếu Khách hàng không muốn nhận thông báo từ ứng dụng cung cấp dịch vụ của
                                VNPT, vui lòng điều chỉnh cài đặt thông báo trong ứng dụng cung cấp dịch vụ hoặc thiết
                                bị của mình.
                            </div>
                        </p>
                    </div>
                </div>
                <div className="title-tree">
                    <div>5.</div>
                    <div>
                        Quyền xóa Thông tin Khách hàng
                        <br/>
                        Khách hàng có quyền yêu cầu VNPT thực hiện xóa Thông tin Khách hàng của mình với điều kiện yêu
                        cầu của Khách hàng phù hợp với quy định của pháp luật.
                        <br/>
                        Tuy nhiên, yêu cầu xóa Thông tin Khách hàng bắt buộc cung cấp theo quy định pháp luật sẽ dẫn tới
                        việc VNPT không thể cung cấp Sản phẩm, dịch vụ cho Khách hàng, điều này đồng nghĩa với việc VNPT
                        có thể đơn phương chấm dứt hợp đồng mà không cần phải bồi thường cho Khách hàng do các điều kiện
                        để thực hiện hợp đồng đã thay đổi (trừ trường hợp do lỗi của VNPT hoặc pháp luật có quy định
                        khác).
                    </div>
                </div>
                <div className="title-tree">
                    <div>6.</div>
                    <div>
                        Quyền khiếu nại, tố cáo, khởi kiện
                        <br/>
                        Khách hàng có quyền khiếu nại, tố cáo hoặc khởi kiện theo quy định của pháp luật.
                    </div>
                </div>
                <div className="title-tree">
                    <div>7.</div>
                    <div>
                        Quyền yêu cầu bồi thường thiệt hại
                        <br/>
                        Khách hàng có quyền yêu cầu bồi thường thiệt hại theo quy định của pháp luật khi xảy ra vi phạm
                        quy định về bảo vệ Thông tin Khách hàng của mình, trừ trường hợp các bên có thỏa thuận khác hoặc
                        luật có quy định khác.
                    </div>
                </div>
                <div className="title-tree">
                    <div>8.</div>
                    <div>Quyền yêu cầu cơ quan có thẩm quyền hoặc cơ quan, tổ chức, cá nhân liên quan đến xử lý dữ liệu
                        cá nhân thực hiện các biện pháp, giải pháp bảo vệ dữ liệu cá nhân của mình theo quy định của
                        pháp luật.
                    </div>
                </div>
                <br/>


                <h3>Điều 6. Nghĩa vụ của Khách hàng</h3>
                <div>Khách hàng có trách nhiệm bảo vệ Thông tin Khách hàng của mình như sau:</div>
                <div className="title-tree">
                    <div>1.</div>
                    <div>Tự bảo vệ dữ liệu cá nhân của mình;</div>
                </div>
                <div className="title-tree">
                    <div>2.</div>
                    <div>Chủ động thực hiện các biện pháp bảo vệ, quản lý và sử dụng an toàn tài khoản, thiết bị công
                        nghệ cá nhân (bao gồm các thiết bị như điện thoại thông minh, máy tính, máy tính bảng, laptop)
                        bằng cách đăng xuất tài khoản sau khi sử dụng, đặt một mật khẩu mạnh<sup>1</sup> và giữ bí mật thông tin
                        đăng nhập cũng như mật khẩu của mình. Các biện pháp bảo vệ và quản lý sử dụng an toàn tài khoản,
                        thiết bị di động nói trên giúp ngăn chặn việc truy cập trái phép vào tài khoản của Khách hàng.
                        VNPT được loại trừ trách nhiệm với các thiệt hại của Khách hàng trong trường hợp Khách hàng bị
                        lộ/mất, bị đánh cắp mật khẩu, dẫn tới việc bị truy cập trái phép vào tài khoản, hoặc bất kỳ hoạt
                        động nào trên tài khoản của Khách hàng sử dụng trên thiết bị di động bị mất, thất lạc dẫn đến
                        người không có thẩm quyền tự ý sử dụng dịch vụ, hoặc hệ thống của VNPT bị xâm phạm bất hợp pháp
                        bởi bên thứ ba mặc dù VNPT đã thực hiện đầy đủ các biện pháp để bảo vệ hệ thống (trừ trường hợp
                        do lỗi của VNPT);
                    </div>
                </div>
                <div className="title-tree">
                    <div>3.</div>
                    <div>Khi đã chấp thuận điều khoản và điều kiện của Chính sách này, Khách hàng có trách nhiệm cung cấp, cập nhật Thông tin Khách hàng đầy đủ, chính xác theo quy định của pháp luật, theo hợp đồng hoặc khi đồng ý cho phép xử lý dữ liệu cá nhân của mình và có trách nhiệm thông báo cho VNPT ngay khi phát hiện hành vi vi phạm quy định về bảo vệ Thông tin Khách hàng;</div>
                </div>
                <div className="title-tree">
                    <div>4.</div>
                    <div>Khách hàng có trách nhiệm tôn trọng Thông tin Khách hàng của chủ thể khác và thực hiện quy định của pháp luật về bảo vệ Thông tin Khách hàng, tham gia phòng, chống hoạt động xâm phạm Thông tin Khách hàng.</div>
                </div>
                <br/>


                <h3>Điều 7. Các nguyên tắc khi thực hiện quyền và nghĩa vụ của Khách hàng</h3>
                <div>1. Khách hàng khi thực hiện quyền và nghĩa vụ của mình phải tuân thủ đầy đủ các nguyên tắc sau
                    đây:
                </div>
                <div className="title-tree">
                    <div>a)</div>
                    <div>Thực hiện theo quy định của pháp luật; tuân thủ nghĩa vụ của Khách hàng theo hợp đồng. Việc
                        thực hiện quyền và nghĩa vụ của Khách hàng phải nhằm mục đích bảo vệ quyền, lợi ích hợp pháp của
                        chính khách hàng đó;
                    </div>
                </div>
                <div className="title-tree">
                    <div>b)</div>
                    <div>Không gây khó khăn, cản trở việc thực hiện quyền, nghĩa vụ pháp lý của VNPT và của các bên khác
                        theo quy định của Luật Bảo vệ dữ liệu cá nhân;
                    </div>
                </div>
                <div className="title-tree">
                    <div>c)</div>
                    <div>Không xâm phạm đến quyền, lợi ích hợp pháp của Nhà nước, cơ quan, tổ chức, cá nhân khác.</div>
                </div>
                <br/>
                <div>2. Trường hợp Khách hàng thực hiện các quyền được quy định tại Điều 5 Chính sách này nhưng không
                    đảm bảo đầy đủ các nguyên tắc nêu tại khoản 1 Điều này hoặc không thực hiện quy trình, thủ tục phù
                    hợp với hướng dẫn của VNPT trong từng thời kỳ, VNPT có thể xem xét từ chối thực hiện các yêu cầu của
                    Khách hàng cho đến khi Khách hàng đảm bảo đầy đủ các điều kiện nêu trên.
                </div>
                <br/>


                <h3>Điều 8. Xử lý dữ liệu của khách hàng dưới 16 tuổi</h3>
                <div className="title-tree">
                    <div>1.</div>
                    <div>Đối với khách hàng cá nhân từ đủ 7 (bảy) tuổi đến dưới 16 (mười sáu) tuổi (“<b>Khách hàng trẻ
                        em</b>”), VNPT sẽ thực hiện xác minh độ tuổi của Khách hàng trẻ em trước khi xử lý Thông tin
                        khách hàng.
                    </div>
                </div>
                <div className="title-tree">
                    <div>2.</div>
                    <div>Trong trường hợp Khách hàng trẻ em mua, đăng ký sử dụng, sử dụng sản phẩm, dịch vụ của VNPT,
                        VNPT sẽ thực hiện lấy ý kiến đồng ý của trẻ em thông qua cha, mẹ hoặc người giám hộ. Cha, mẹ
                        hoặc người giám hộ của Khách hàng trẻ em sẽ đánh dấu xác nhận thể hiện sự đồng ý liên quan đến
                        việc xử lý Dữ liệu cá nhân của Khách hàng trẻ em trừ trường hợp pháp luật có quy định khác.
                    </div>
                </div>
                <br/>


                <h3>Điều 9. Lưu trữ Thông tin Khách hàng</h3>
                <div className="title-tree">
                    <div>1.</div>
                    <div>Địa điểm lưu trữ Thông tin Khách hàng: Trong phạm vi pháp luật cho phép, VNPT có thể lưu trữ
                        Thông tin Khách hàng của Khách hàng tại Việt Nam và ở nước ngoài, kể cả trên giải pháp lưu trữ
                        điện toán đám mây. VNPT áp dụng các tiêu chuẩn về bảo mật dữ liệu phù hợp với quy định pháp luật
                        hiện hành.
                    </div>
                </div>
                <div className="title-tree">
                    <div>2.</div>
                    <div>Thời gian lưu trữ Thông tin Khách hàng: Trừ trường hợp pháp luật có quy định khác, VNPT chỉ
                        thực hiện lưu trữ Thông tin Khách hàng của Khách hàng để hoàn thành các Mục đích bắt buộc (và
                        các Mục đích tùy chọn trong trường hợp được Khách hàng đồng ý) quy định tại Chính sách này.
                    </div>
                </div>
                <br/>


                <h3>Điều 10. Nghĩa vụ và biện pháp bảo vệ Thông tin khách hàng của VNPT</h3>
                <p className="title-tree">
                    <div>1.</div>
                    <div>
                        Thông tin Khách hàng của Khách hàng được cam kết bảo mật theo quy định của pháp luật, Chính sách
                        bảo vệ Thông tin Khách hàng của VNPT. VNPT có thể sử dụng công nghệ để xử lý Thông tin khách
                        hàng, đồng thời áp dụng các biện pháp bảo vệ Thông tin Khách hàng phù hợp với quy định của pháp
                        luật, trong đó các biện pháp ngăn chặn các hành vi sau đây:
                        <div className="title-tree">
                            {/*<div>○</div>*/}
                            <div>a) Đánh cắp hoặc tiếp cận thông tin trái phép;</div>
                        </div>
                        <div className="title-tree">
                            {/*<div>○</div>*/}
                            <div>b) Sử dụng thông tin trái phép;</div>
                        </div>
                        <div className="title-tree">
                            {/*<div>○</div>*/}
                            <div>c) Chỉnh sửa, cập nhật, hủy bỏ thông tin trái phép.</div>
                        </div>
                    </div>
                </p>
                <p className="title-tree">
                    <div>2.</div>
                    <div>
                        VNPT áp dụng những biện pháp vật lý, điện tử và quản lý để bảo vệ Thông tin Khách hàng, bao gồm:
                        <div className="title-tree">
                            {/*<div>○</div>*/}
                            <div>a) Các máy chủ trang thông tin điện tử chính thức của VNPT và các hệ thống thông tin chứa Thông tin Khách hàng của VNPT đều được bảo vệ bởi các biện pháp, công nghệ bảo mật như tường lửa, mã hóa, chống xâm nhập trái phép; ban hành các biện pháp kiểm soát về con người, xây dựng quy trình kiểm tra, đánh giá, rà soát để phòng tránh các hành vi vi phạm quy định về bảo vệ Thông tin Khách hàng.</div>
                        </div>
                        <div className="title-tree">
                            {/*<div>○</div>*/}
                            <div>b) VNPT sẽ thực hiện tất cả các biện pháp cần thiết để đảm bảo rằng Thông tin Khách hàng của Khách hàng được xử lý đúng với Mục Đích đã thông báo và được Khách hàng đồng ý. VNPT sẽ luôn tuân thủ những yêu cầu của pháp luật liên quan đến việc xử lý Thông tin Khách hàng.</div>
                        </div>
                    </div>
                </p>
                <p className="title-tree">
                    <div>3.</div>
                    <div>Thực hiện các yêu cầu của Khách hàng liên quan đến Thông tin Khách hàng của Khách hàng với điều
                        kiện các yêu cầu của Khách hàng phải phù hợp với quy định của pháp luật và phù hợp với các quy
                        trình, thủ tục theo hướng dẫn của VNPT trong từng thời kỳ.
                    </div>
                </p>
                <p className="title-tree">
                    <div>4.</div>
                    <div>Trong trường hợp hệ thống thông tin bị tấn công làm phát sinh nguy cơ mất an toàn, an ninh
                        Thông tin Khách hàng, VNPT hoặc bên lưu trữ thông tin liên quan phải thông báo cho cơ quan quản
                        lý nhà nước có thẩm quyền trong thời hạn theo quy định của pháp luật và thực hiện các biện pháp
                        cần thiết để bảo đảm an toàn, an ninh Thông tin Khách hàng theo quy định của pháp luật về an
                        ninh mạng, an toàn thông tin mạng, giao dịch điện tử và quy định khác của pháp luật có liên
                        quan.
                    </div>
                </p>
                <p className="title-tree">
                    <div>5.</div>
                    <div>Các nghĩa vụ khác theo quy định của pháp luật và của Chính sách này.</div>
                </p>


                <h3>Điều 11. Quảng cáo trên internet và bên thứ ba</h3>
                <p>Các website/ứng dụng cung cấp dịch vụ của VNPT có thể bao gồm quảng cáo của bên thứ ba và liên kết
                    tới các website/ứng dụng cung cấp dịch vụ khác. Các đối tác quảng cáo bên thứ ba có thể thu thập
                    thông tin về Khách hàng khi Khách hàng tương tác với nội dung, quảng cáo hoặc dịch vụ của họ. Mọi
                    quyền truy cập và sử dụng các liên kết hoặc trang website của bên thứ ba không bị điều chỉnh bởi
                    Chính sách này, mà thay vào đó được điều chỉnh bởi chính sách quyền riêng tư của các bên thứ ba
                    đó.</p>


                <h3>Điều 12. Luật áp dụng</h3>
                <p>Chính sách này được soạn thảo và điều chỉnh bởi pháp luật Việt Nam.</p>


                <h3>Điều 13. Thông tin liên lạc</h3>
                <p>
                    Trường hợp Khách hàng có bất kỳ câu hỏi nào về Chính sách này hoặc muốn thực hiện các quyền của Khách hàng liên quan tới Thông tin Khách hàng, vui lòng liên hệ với VNPT theo các phương thức và thông tin dưới đây:
                    <div className="title-tree">
                        <div>1.</div>
                        <div>Liên hệ tới tổng đài theo thông tin tại các website/ứng dụng cung cấp dịch vụ chính thức của VNPT tại từng thời điểm.</div>
                    </div>
                    <div className="title-tree">
                        <div>2.</div>
                        <div>Liên hệ trực tiếp tại các điểm giao dịch của VNPT trên phạm vi toàn quốc.</div>
                    </div>
                    <div className="title-tree">
                        <div>3.</div>
                        <div>Các cách thức liên hệ khác như Livechat (phần mềm trò chuyện trực tuyến), liên hệ qua fanpage (trang thông tin điện tử) chính thức của VNPT, email chăm sóc Khách hàng được cung cấp cho Khách hàng tại mọi thời điểm.</div>
                    </div>
                </p>

                {showDocuments && (
                    <>
                        <br/>
                        <div className="border-bottom"></div>
                        <h3>Tài liệu chính sách bảo vệ thông tin khách hàng</h3>
                        <div className="document-list">
                            {[
                                {
                                    label: '5203 TB Sở công thương về việc hoàn thành đăng ký hợp đồng mẫu 15062026',
                                    file: '5203_TB_So_cong_thuong_hoan_thanh_dang_ky_hop_dong_mau_15062026.pdf'
                                },
                                {
                                    label: 'Mẫu 00 Phụ lục xác nhận đồng ý với mục đích sử dụng thông tin KH',
                                    file: 'Mau_00_PL_xac_nhan_dong_y_muc_dich_su_dung_thong_tin_KH.pdf'
                                },
                                {
                                    label: 'Mẫu 01 KHCN Bản xác nhận thông tin thuê bao 2026',
                                    file: 'Mau_01_KHCN_Ban_xac_nhan_thong_tin_thue_bao_2026.pdf'
                                },
                                {
                                    label: 'Mẫu 02 KHCN Hợp đồng cung cấp và sử dụng dịch vụ viễn thông, truyền hình trả trước 2026',
                                    file: 'Mau_02_KHCN_HD_cung_cap_dich_vu_vien_thong_truyen_hinh_tra_truoc_2026.pdf'
                                },
                                {
                                    label: 'Mẫu 03 KHCN Hợp đồng cung cấp và sử dụng dịch vụ viễn thông truyền hình trả sau 2026',
                                    file: 'Mau_03_KHCN_HD_cung_cap_dich_vu_vien_thong_truyen_hinh_tra_sau_2026.pdf'
                                },
                                {
                                    label: 'Mẫu 06.1 PL1 Danh sách cá nhân được giao sử dụng 2026',
                                    file: 'Mau_06.1_PL1_Danh_sach_ca_nhan_duoc_giao_su_dung_2026.pdf'
                                },
                                {
                                    label: 'Mẫu 06.2 PL2 Danh sách thuê bao sử dụng thiết bị 2026',
                                    file: 'Mau_06.2_PL2_Danh_sach_thue_bao_su_dung_thiet_bi_2026.pdf'
                                },
                                {
                                    label: 'Mẫu 07 Phiếu yêu cầu thực hiện quyền của Chủ thể dữ liệu 2026',
                                    file: 'Mau_07_Phieu_yeu_cau_thuc_hien_quyen_Chu_the_du_lieu_2026.pdf'
                                },
                                {
                                    label: 'Mẫu 07.1 Phụ lục thông báo rủi ro khi rút lại đồng ý xử lý DLCN',
                                    file: 'Mau_07.1_PL_thong_bao_rui_ro_rut_lai_dong_y_xu_ly_DLCN.pdf'
                                },
                                {
                                    label: 'Mẫu 09 Thỏa thuận xử lý dữ liệu cá nhân 2026',
                                    file: 'Mau_09_Thoa_thuan_xu_ly_du_lieu_ca_nhan_2026.pdf'
                                },
                            ].map((doc, index) => (
                                <div key={index} className="document-item">
                                    <a
                                        href={`${process.env.PUBLIC_URL}/documents/${doc.file}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{textDecoration: 'underline', color: '#0066cc', cursor: 'pointer'}}
                                    >
                                        {doc.label}
                                    </a>
                                </div>
                            ))}
                        </div>
                    </>
                )}

                <br/>
                <br/>
                <div className="border-bottom"></div>
                <br/>
                <p><sup>1</sup> Mật khẩu mạnh phải đảm bảo các yếu tố sau:</p>
                <div className="title-tree">
                    <div>●</div>
                    <div>Sử dụng tối thiểu 8 ký tự, và tối đa 15 ký tự.</div>
                </div>
                <div className="title-tree">
                    <div>●</div>
                    <div>Bao gồm số, chữ thường, chữ in hoa và ký tự đặc biệt.</div>
                </div>
                <div className="title-tree">
                    <div>●</div>
                    <div>Duy nhất, không dùng chung cho các tài khoản khác.</div>
                </div>
                <div className="title-tree">
                    <div>●</div>
                    <div>Không được mang ý nghĩa đi kèm (số điện thoại, ngày sinh, tên địa danh...).</div>
                </div>
                <div className="title-tree">
                    <div>●</div>
                    <div>Không sử dụng tên riêng.</div>
                </div>
                <div className="title-tree">
                    <div>●</div>
                    <div>Không sử dụng các con số nổi tiếng, ví dụ: 113, 115, 12345678...</div>
                </div>
                <div className="title-tree">
                    <div>●</div>
                    <div>Không sử dụng các thông tin trong mật khẩu cho câu hỏi bí mật (câu hỏi bí mật là phương pháp giúp người dùng đặt lại mật khẩu khi quên).</div>
                </div>


                {/*&emsp;<b>Đối với ứng dụng MyVNPT</b>, Quý khách có thể chủ động thực hiện thao tác xóa tài khoản được*/}
                {/*tạo ra khi đăng nhập bằng Google, Facebook và Apple ID theo hướng dẫn <a href='#'*/}
                {/*                                                                         style={{'textDecoration': 'underline'}}*/}
                {/*                                                                         onClick={e => {*/}
                {/*                                                                             {*/}
                {/*                                                                                 e.preventDefault();*/}
                {/*                                                                                 setDelAccInstru(!delAccInstru)*/}
                {/*                                                                             }*/}
                {/*                                                                         }}>tại đây</a>.<br/>*/}
            </div>


            {/*<div className='term-delAcc-detail'>*/}
            {/*    {delAccInstru === true && (*/}
            {/*        <div className="pdfWrapperBG">*/}
            {/*            <div className="pdfWrapper">*/}
            {/*                <div className="topBar">*/}
            {/*                    <div className="closeBtn">*/}
            {/*                        <button type="button" class="close" onClick={e => {*/}
            {/*                            {*/}
            {/*                                e.preventDefault();*/}
            {/*                                setDelAccInstru(false)*/}
            {/*                            }*/}
            {/*                        }}>*/}
            {/*                            <span aria-hidden="true">×</span>*/}
            {/*                            <span class="sr-only">Close</span>*/}
            {/*                        </button>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                {delAccFunc()}*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*    )}*/}
            {/*</div>*/}
        </div>
    );
}

export default React.memo(PrivacyPolicy);
